import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { StoreState } from '../App';
import {
  AxisStructuredDataIndustry,
  AxisStructuredDataInquiryType,
  AxisStructuredDataSubIndustry,
  AxisStructuredDataTypeEnum,
  AxisStructuredDataInput,
} from '../gql/graphql';

export interface AxisStructuredData {
  inquiryType: AxisStructuredDataInquiryType | '';
  type: AxisStructuredDataTypeEnum | '';
  industry: AxisStructuredDataIndustry | '';
  subIndustry: AxisStructuredDataSubIndustry | '';
}

export interface AxisState {
  structuredData: AxisStructuredData;
}

export const defaultAxisStructuredData: AxisStructuredData = {
  inquiryType: '',
  type: '',
  industry: '',
  subIndustry: '',
};

const initialState: AxisState = {
  structuredData: defaultAxisStructuredData,
};

export const axisStore = createSlice({
  name: 'axis',
  initialState,
  reducers: {
    setAxisStructuredData: (
      state,
      action: PayloadAction<Partial<AxisStructuredData>>,
    ) => {
      state.structuredData = {
        ...state.structuredData,
        ...action.payload,
      };
    },
    resetAxisState: (state) => {
      state.structuredData = { ...defaultAxisStructuredData };
    },
  },
});

export const getAxisStructuredData = (state: StoreState) => {
  return state.axisStore.structuredData;
};

export const hasAxisQuoteEntryData = (state: StoreState): boolean => {
  const { inquiryType, type, industry } = state.axisStore.structuredData;
  return Boolean(inquiryType && type && industry);
};

export const toAxisStructuredDataInput = (
  structuredData: AxisStructuredData,
): AxisStructuredDataInput | undefined => {
  const input: AxisStructuredDataInput = {
    inquiryType: structuredData.inquiryType || undefined,
    type: structuredData.type || undefined,
    industry: structuredData.industry || undefined,
    subIndustry: structuredData.subIndustry || undefined,
  };

  if (
    !input.inquiryType &&
    !input.type &&
    !input.industry &&
    !input.subIndustry
  ) {
    return undefined;
  }

  return input;
};

export const { setAxisStructuredData, resetAxisState } = axisStore.actions;

export default axisStore;
